import {getFeatureServices} from '../../infrastructure/hub/initializeHub';
import {
    FeatureHub,
    FeatureServiceProviderDefinition,
    SharedFeatureService
} from '@feature-hub/core';

export function createServices(
    featureHub: FeatureHub,
    moduleDefinitionsMap: {
        moduleDef: FeatureServiceProviderDefinition<SharedFeatureService>;
        bundle: string;
    }[]
) {
    const sharedFeatureServices = getFeatureServices(featureHub);
    const services: {id: string; versions: string[]; source: string}[] = [];
    sharedFeatureServices.forEach((value, key) => {
        const versions = Object.keys(value).sort().reverse();
        const service = {
            id: key,
            versions,
            source:
                moduleDefinitionsMap.find(e => e.moduleDef.id === key)
                    ?.bundle || 'cms'
        };
        services.push(service);
    });
    return services;
}
